import classes from './ModalWithContent.module.scss';
import { IModalWithContent } from '../../../utils/interfaces';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import { Close } from '../../../assets/icons/Close';
import {PropsWithChildren} from 'react';

export const ModalWithContent = ({
  actions,
  open,
  title,
  showCancelButton = true,
  onClose,
  children,
}: PropsWithChildren<IModalWithContent>) => {
  return (
    <Dialog classes={{ paper: classes.modalContainer }} open={open} onClose={onClose}>
      <DialogTitle className={classes.modalHeader}>
        <div className={classes.modalTitle}>
          {title}
        </div>
        <IconButton edge="start" color="inherit" onClick={onClose} aria-label="close">
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.modalBody}>
        {children}
      </DialogContent>
      <DialogActions className={classes.actions}>
        {actions}
        {showCancelButton && (
          <Button
            className={classes.action}
            color="secondary"
            onClick={onClose}
            variant="outlined">
            Cancel
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
